import { DateTime } from "luxon";
import { ROCK_HALL_PLACE } from "./venue";

const ZONE = "America/New_York";

export type MusicEventInput = {
  name: string;
  url: string;
  startDate?: string | null;
  endDate?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  ticketLink?: string | null;
  performerNames?: (string | null | undefined)[];
};

function toIso(value?: string | null): string | undefined {
  if (!value) return undefined;
  const naive = value.trim().replace(/(?:Z|[+-]00:00)$/, "");
  const parsed = DateTime.fromISO(naive, { zone: ZONE });
  return parsed.isValid
    ? parsed.toISO({ suppressMilliseconds: true }) ?? undefined
    : undefined;
}

function performers(names?: (string | null | undefined)[]) {
  const groups = (names ?? [])
    .map((n) => (n ?? "").trim())
    .filter(Boolean)
    .map((name) => ({ "@type": "MusicGroup", name }));
  if (groups.length === 0) return undefined;
  return groups.length === 1 ? groups[0] : groups;
}

export function buildMusicEvent(input: MusicEventInput): Record<string, unknown> {
  const start = toIso(input.startDate);
  const end = toIso(input.endDate);
  const perf = performers(input.performerNames);

  const event: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "MusicEvent",
    name: input.name,
    url: input.url,
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: ROCK_HALL_PLACE,
    organizer: {
      "@type": "Organization",
      name: "Rock & Roll Hall of Fame",
      url: "https://rockhall.com/",
    },
  };

  if (start) event.startDate = start;
  if (end) event.endDate = end;
  if (input.description) event.description = input.description;
  if (input.imageUrl) event.image = input.imageUrl;
  if (perf) event.performer = perf;
  if (input.ticketLink) {
    event.offers = {
      "@type": "Offer",
      url: input.ticketLink,
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
    };
  }
  return event;
}
